import { selectTaxesDisplaySetting } from '@gandi/authentication';
import { useTranslator } from '@gandi/translate';
import { useAppSelector } from '../../../../../hooks/useAppSelector';
import { selectRawBundleById } from '../../../../../modules/bundles';
export function useGetCartBundlePrice() {
  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);
  return bundle => ({
    price: bundle[taxesIncluded ? 'priceAfterTaxes' : 'priceBeforeTaxes'],
    crossedPrice: bundle[taxesIncluded ? 'productsbeforeDiscountAfterTaxes' : 'productsbeforeDiscountBeforeTaxes']
  });
}
export function useGetCartTotalPrice() {
  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);
  return cartTotal => cartTotal[taxesIncluded ? 'afterTaxes' : 'beforeTaxes'];
}
export function useGetTotalPrice() {
  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);
  return total => total[taxesIncluded ? 'after_taxes' : 'before_taxes'];
}
export function useGetComputedTotalPrice() {
  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);
  return computedTotal => taxesIncluded ? computedTotal.beforeTaxes * (1 + computedTotal.rate / 100) : computedTotal.beforeTaxes;
}
function getBestPrice(payload) {
  const {
    duration,
    unit
  } = payload;
  const bestPrice = payload.shopping?.best_price;
  if (!bestPrice) return undefined;
  if ((!unit || unit === bestPrice.duration_unit) && parseInt(duration, 10) >= bestPrice.min_duration && parseInt(duration, 10) <= bestPrice.max_duration) {
    return bestPrice;
  }
  return undefined;
}
export function useGetCrossedPrice() {
  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);
  return ({
    discountPrice,
    payload
  }) => {
    const beforeDiscount = taxesIncluded ? discountPrice.beforeDiscountAfterTaxes : discountPrice.beforeDiscountBeforeTaxes;
    const bestPrice = getBestPrice(payload);
    if (!bestPrice) return beforeDiscount;
    const unitNormalPrice = taxesIncluded ? bestPrice.normal_price_after_taxes : bestPrice.normal_price_before_taxes;
    if (!unitNormalPrice || !payload.duration) return beforeDiscount;
    const normalPrice = unitNormalPrice * payload.duration;
    if (beforeDiscount == null) return normalPrice;
    return Math.max(beforeDiscount, normalPrice);
  };
}
export function useBundleDescription(bundle) {
  const {
    __
  } = useTranslator();
  const rawBundle = useAppSelector(state => selectRawBundleById(state, bundle.id));
  const isWP1ClickBundle = rawBundle?.type === 'WP1CLICK';
  const isDomainBundle = !rawBundle?.is_partial_type && bundle.products.every(product => product.productType === 'domain');
  if (isWP1ClickBundle) {
    return __('WordPress hosting');
  }
  if (isDomainBundle) {
    return __('Domain bundle');
  }
  return __('-50%% Hosting + free .fr - 12 months');
}